export interface ModalOneConfig {
 visible?: boolean;
  modalTitle?: string;
  modalTitleDescription?: string;
  founderImage?: string;
  ariaLabelledBy?: string;
}

export const DEFAULT_MODALONE_CONFIG: ModalOneConfig = {
  visible: false,
  modalTitle: '',
  modalTitleDescription: '',
  founderImage: '',
  ariaLabelledBy: 'staticBackdropLabel'
}